module.exports = __webpack_public_path__ + "img/00.a91bc0f1.jpg";